"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section } from "@/src/components";
import { InstallCommand } from "@/components/docs/install-command";

export default function DocsComponentsKanban() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Kanban
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            A drag-and-drop kanban board for task management and workflow visualization.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/kanban" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Overview</CardTitle>
              <CardDescription>A kanban board with columns and cards</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <Text className="text-sm text-muted-foreground">
            The Kanban component provides a flexible drag-and-drop interface for managing tasks
            across different stages. It supports customizable columns, card rendering, and
            drag-and-drop functionality.
          </Text>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Features</CardTitle>}
          contentClassName="p-6"
        >
          <ul className="space-y-2 text-sm">
            <li>• Drag and drop cards between columns</li>
            <li>• Customizable column headers and card content</li>
            <li>• Reorderable cards within columns</li>
            <li>• Keyboard accessible</li>
            <li>• Touch device support</li>
          </ul>
        </SectionCard>
      </Section>
    </>
  );
}
